<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("OTHER_SERVICE.show_order") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="orderData">
      <form>
        <div class="row">
          <!-- ============ Start:: Order Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.order_data_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_date')"
            v-model.trim="orderData.created_at"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_number')"
            v-model.trim="orderData.id"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_status')"
            v-model.trim="orderData.status_label"
            disabled
          />
          <!-- ============ End:: Order Data Section ============ -->

          <!-- ============ Start:: Horse Data Section ============ -->
          <template v-if="orderData.horse">
            <div class="form_title_wrapper">
              <h4>{{ $t("OTHER_SERVICE.horse_data_section") }}</h4>
            </div>

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.horse_name')"
              v-model.trim="orderData.horse.name"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.average_rating')"
              v-model.trim="orderData.horse.rating"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.breed_type')"
              v-model.trim="orderData.horse.breed"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.gender')"
              v-model.trim="orderData.horse.gender"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.age')"
              v-model.trim="orderData.horse.age"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.color')"
              v-model.trim="orderData.horse.color"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.health_status')"
              v-model.trim="orderData.horse.health_status"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.training_level')"
              v-model.trim="orderData.horse.training_level"
              disabled
            />
          </template>
          <!-- ============ End:: Horse Data Section ============ -->

          <!-- ============ Start:: Service Provider Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData.provider">
            <h4>{{ $t("OTHER_SERVICE.provider_data_section") }}</h4>
          </div>

          <template v-if="orderData.provider">
            <base-image-upload-input
              col="12"
              :disabled="true"
              identifier="provider_avatar"
              :placeholder="$t('OTHER_SERVICE.provider_logo')"
              :preSelectedImage="orderData.provider?.avatar"
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('OTHER_SERVICE.provider_name')"
              v-model.trim="orderData.provider.name"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('OTHER_SERVICE.average_rating')"
              v-model.trim="orderData.provider.rating"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('OTHER_SERVICE.city')"
              v-model.trim="orderData.provider.city"
              disabled
            />

            <!-- Provider Location Map -->
            <div
              class="col-12"
              v-if="orderData.provider.latitude && orderData.provider.longitude"
            >
              <label class="mb-2">{{ $t("OTHER_SERVICE.location_map") }}</label>
              <MapComponent
                :lat="parseFloat(orderData.provider.latitude)"
                :lng="parseFloat(orderData.provider.longitude)"
              />
            </div>
          </template>
          <!-- ============ End:: Service Provider Data Section ============ -->

          <!-- ============ Start:: Service Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData?.service">
            <h4>{{ $t("OTHER_SERVICE.service_data_section") }}</h4>
          </div>

          <template v-if="orderData?.service">
            <base-input
              col="6"
              type="text"
              :placeholder="$t('OTHER_SERVICE.service_name')"
              v-model.trim="orderData.service.name"
              disabled
            />

            <base-input
              col="6"
              type="text"
              :placeholder="$t('OTHER_SERVICE.service_price')"
              :value="
                orderData.service.price
                  ? orderData.service.price + ' ' + $t('PLACEHOLDERS.riyal')
                  : '-'
              "
              disabled
            />

            <base-input
              col="12"
              type="textarea"
              rows="3"
              :placeholder="$t('OTHER_SERVICE.service_description')"
              v-model.trim="orderData.service.description"
              disabled
            />

            <!-- Service Images -->
            <div
              class="col-12"
              v-if="orderData.service.images && orderData.service.images.length"
            >
              <label class="mb-2">{{
                $t("OTHER_SERVICE.service_images")
              }}</label>
              <div class="images_gallery">
                <img
                  v-for="(image, index) in orderData.service.images"
                  :key="index"
                  :src="image"
                  :alt="`Service Image ${index + 1}`"
                  class="service_image"
                />
              </div>
            </div>

            <!-- Service Video -->
            <div class="col-12" v-if="orderData.service.video">
              <label class="mb-2">{{
                $t("OTHER_SERVICE.service_video")
              }}</label>
              <video controls class="service_video">
                <source :src="orderData.service.video" type="video/mp4" />
                {{ $t("GENERAL.video_not_supported") }}
              </video>
            </div>
          </template>
          <!-- ============ End:: Service Data Section ============ -->

          <!-- ============ Start:: Booking Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.booking_data_section") }}</h4>
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('OTHER_SERVICE.booking_date')"
            v-model.trim="orderData.service_date"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('OTHER_SERVICE.booking_time')"
            v-model.trim="orderData.service_time"
            disabled
          />

          <!-- Customer Location -->
          <div class="col-12" v-if="orderData.latitude && orderData.longitude">
            <label class="mb-2">{{
              $t("OTHER_SERVICE.customer_location")
            }}</label>
            <MapComponent
              :lat="parseFloat(orderData.latitude)"
              :lng="parseFloat(orderData.longitude)"
            />
          </div>

          <base-input
            v-if="orderData.location"
            col="12"
            type="text"
            :placeholder="$t('OTHER_SERVICE.customer_location')"
            v-model.trim="orderData.location"
            disabled
          />

          <!-- Horse Images if exists -->
          <div
            class="col-12"
            v-if="
              orderData.horse &&
              orderData.horse.images &&
              orderData.horse.images.length
            "
          >
            <label class="mb-2">{{ $t("OTHER_SERVICE.horse_image") }}</label>
            <div class="images_gallery">
              <img
                v-for="(image, index) in orderData.horse.images"
                :key="index"
                :src="image"
                :alt="`Horse Image ${index + 1}`"
                class="service_image"
              />
            </div>
          </div>

          <!-- Horse Video if exists -->
          <div class="col-12" v-if="orderData.horse && orderData.horse.video">
            <label class="mb-2">{{ $t("OTHER_SERVICE.horse_video") }}</label>
            <video controls class="service_video">
              <source :src="orderData.horse.video" type="video/mp4" />
              {{ $t("GENERAL.video_not_supported") }}
            </video>
          </div>

          <base-input
            col="12"
            type="textarea"
            rows="3"
            :placeholder="$t('OTHER_SERVICE.notes')"
            v-model.trim="orderData.notes"
            disabled
          />
          <!-- ============ End:: Booking Data Section ============ -->

          <!-- ============ Start:: Price and Payment Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.price_payment_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.payment_method')"
            :value="getPaymentMethodLabel(orderData.payment_method)"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.service_price')"
            :value="
              orderData.sub_total
                ? orderData.sub_total + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.tax')"
            :value="
              orderData.tax
                ? orderData.tax + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.total')"
            :value="
              orderData.total
                ? orderData.total + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />
          <!-- ============ End:: Price and Payment Data Section ============ -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import MapComponent from "../../../components/general/MapComponent.vue";

export default {
  name: "ShowOtherService",
  components: {
    MapComponent,
  },

  data() {
    return {
      isWaitingRequest: false,
      orderData: {
        provider: {},
        service: {},
        horse: null,
      },
    };
  },

  methods: {
    // Start:: Show Order
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        this.orderData = res.data.data.order;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || "Error loading order"
        );
      }
    },
    // End:: Show Order

    // Start:: Get Payment Method Label
    getPaymentMethodLabel(method) {
      if (method === "wallet") {
        return this.$t("PAYMENT_METHODS.wallet");
      } else if (method === "online" || method === "electronic") {
        return this.$t("PAYMENT_METHODS.electronic");
      }
      return method;
    },
    // End:: Get Payment Method Label
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.form_title_wrapper {
  margin-top: 20px;
  margin-bottom: 15px;
}

.images_gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.service_image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.service_video {
  width: 100%;
  max-width: 600px;
  border-radius: 8px;
  margin-top: 10px;
}

label.mb-2 {
  font-weight: 600;
  color: #333;
  display: block;
}
</style>
